<template>
  <div>
    <!-------------Start toast / snackbar --------------------------->
    <error-toast-component :ErrorToast="ErrorToast" />
    <!-------------end toast / snackbar --------------------------->
    <!--------- heading ------------------->
    <v-row flat>
      <h1 class="heading-1 mobile_size_h1">Member Downloads - Files</h1>
    </v-row>
    <!--------- search , filter and buttons ------------------->
    <v-row class="mt-6" justify="center" align-content="center">
      <v-col cols="12" md="4" sm="6">
        <v-card flat>
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search..."
            single-line
            v-model="search"
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
          @click="filterDialog = true"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-icon>mdi-tune</v-icon>
              <span class="text_style mx-1" style="letter-spacing: 1px"
                >Filters</span
              >
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card>
        <!------------------------fliter-diloag------------------------------------------>
        <v-dialog v-model="filterDialog" max-width="430" persistent>
          <v-card class="py-5">
            <v-card-title
              class="mb-5 d-flex justify-space-between align-center"
            >
              <div class="text-h5"><b> Filters</b></div>
              <div>
                <v-btn text depressed class="pa-0" @click="cleanFilter()">
                  <span
                    class="text_style primary--text"
                    style="letter-spacing: 0px"
                    >Clean filters</span
                  >
                </v-btn>
                <v-icon class="ml-3" @click="filterDialog = false"
                  >mdi-close</v-icon
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-select
                :items="GetDownloadFileGroups"
                item-text="Name"
                item-value="Id"
                v-model="filterObj.groupName"
                :menu-props="{ maxHeight: '400' }"
                outlined
                dense
                hide-details
                label=" Group"
                multiple
                persistent-hint
              ></v-select>
              <v-select
                outlined
                class="my-5"
                dense
                :items="filterLanguage"
                v-model="filterObj.Languages"
                :menu-props="{ maxHeight: '400' }"
                hide-details
                label="Language"
                multiple
                persistent-hint
              ></v-select>
              <v-select
                :items="filtervisbiltyList"
                v-model="filterObj.Visibility"
                outlined
                dense
                :menu-props="{ maxHeight: '400' }"
                hide-details
                label="Visibility"
                persistent-hint
              ></v-select>
              <!-- <v-select
                :items="getMembership"
                v-model="filterObj.MembershipsId"
                :menu-props="{ maxHeight: '400' }"
                item-text="Name"
                item-value="Id"
                outlined
                class="my-5"
                dense
                hide-details
                label=" Membership Type"
                multiple
                persistent-hint
              ></v-select> -->
              <!-- <v-select
                :items="GetCourses"
                v-model="filterObj.CoursesId"
                item-text="Title"
                item-value="Id"
                :menu-props="{ maxHeight: '400' }"
                outlined
                class="my-5"
                dense
                hide-details
                label="Course Prerequisites"
                persistent-hint
              ></v-select> -->
              <!-- <v-select
                outlined
                class="my-5"
                :items="filterPractitionerList"
                v-model="filterObj.Permissions"
                :menu-props="{ maxHeight: '400' }"
                dense
                hide-details
                label=" Practitioner Certification level"
                multiple
                persistent-hint
              ></v-select> -->
              <!-- <v-select
                outlined
                class="my-5"
                :items="InstructorsArray"
                item-text="Name"
                item-value="InstructorId"
                v-model="filterObj.InstructorId"
                :menu-props="{ maxHeight: '400' }"
                dense
                hide-details
                label=" Instructor - Courses Taught"
                persistent-hint
              ></v-select> -->
              <!---------------------Type-modalitiy model filter-------------------------------->
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#646464"
                outlined
                depressed
                class="px-5"
                text
                @click="filterDialog = false"
              >
                <span class="text_style"> Cancel </span>
              </v-btn>
              <v-btn
                color="primary"
                class="px-8 ml-2"
                @click="sendFilters()"
                depressed
              >
                <span class="text_style"> Save Filters </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-end">
        <v-card flat>
          <v-dialog v-model="createnewgroupdialog" persistent max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                block
                color="primary"
                outlined
                v-if="Permission.Add"
                style="text-transform: none"
                >Organize</v-btn
              >
            </template>
            <v-card>
              <div class="mx-8 py-5 d-flex justify-space-between">
                <div>
                  <span class="heading-2"> <b> Organize </b></span>
                  <v-btn color="primary" text @click="newcategorydialog = true">
                    + Create Group
                  </v-btn>
                </div>
                <v-icon @click="createnewgroupdialog = false">mdi-close</v-icon>
              </div>
              <div>
                <createnewgroup-component
                  :GetInstructors="InstructorsArray"
                  :getMembership="getMembership"
                  :groups="GetDownloadFileGroups"
                  @show-delete-toast="
                    showDeleteToast(), (createnewgroupdialog = false)
                  "
                  @show-success-toast="showSuccessToast('Group has been saved')"
                />
              </div>
              <div class="d-flex justify-end mx-5 py-5">
                <v-btn
                  color="primary"
                  class="px-14 py-6 text_style"
                  @click="createnewgroupdialog = false"
                >
                  <span class="pa-4 text_style"> close </span>
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
      <v-col cols="12" md="2">
        <v-card flat>
          <v-dialog v-model="uploadfiledialog" persistent max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                block
                depressed
                v-if="Permission.Add"
                color="primary"
                style="text-transform: none"
                >Add new file</v-btn
              >
            </template>
            <v-card>
              <div class="mx-8 py-5 d-flex justify-space-between">
                <span class="heading-2"> Upload new file </span>
                <v-icon @click="uploadfiledialog = false">mdi-close</v-icon>
              </div>
              <div>
                <UploadfileComponent
                  v-if="uploadfiledialog"
                  @close-dialog="closeModal"
                />
              </div>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <!--------- data table ------------------->
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetDownloadFiles"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b class="index_index_text">
            {{ index + displayedItemsPerPage * (page - 1) + 1 }}
          </b>
        </template>
        <template v-slot:[`item.Title`]="{ item }">
          <span class="table_style_one"> {{ item.Title }} </span>
        </template>

        <template v-slot:[`item.CreatedDate`]="{ item }">
          <span class="table_style_two">{{ checkDate(item.ModifiedDate ? item.ModifiedDate : item.CreatedDate) }}</span>
        </template>
        <template v-slot:[`item.Visibility`]="{ item }">
          <v-btn icon @click="toggleIsPlaying(item)">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Edit"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="downloadFile(item.File)"
                  >
                  <!-- @click="downloadFile(item)" -->
                  <v-icon color="#646464">mdi-tray-arrow-down</v-icon>
                  <span class="ml-4 text_style">Download file</span>
                </v-btn>
              </v-list>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Edit"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="editRow(item)"
                >
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list
                class="px-3 pt-1"
                color="transparent"
                v-if="Permission.Delete"
              >
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="deleteRow(item)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchDownlaodFiles"
      ></v-pagination
    ></v-card>
    <v-dialog v-model="newcategorydialog" persistent max-width="450">
      <v-card>
        <div class="px-8 pt-5 d-flex justify-space-between">
          <h5 class="text_style">Create Group</h5>
          <v-icon @click="closeCategorydialog()">mdi-close</v-icon>
        </div>
        <v-card color="#F6F8FC" flat class="py-5 px-8">
          <v-text-field
            :error-messages="$v.form.Name.$error ? 'Name is required' : null"
            label="Name "
            v-model="form.Name"
          ></v-text-field>
          <b> Permissions </b>
          <v-select
            :error-messages="
              $v.form.Memberships.$error ? 'Membership Type is required' : null
            "
            clearable
            label="Membership Type"
            :items="getMembership"
            item-text="Name"
            item-value="Id"
            v-model="form.Memberships"
            multiple
          ></v-select>

          <v-autocomplete
            clearable
            :items="GetCourses"
            item-text="Title"
            item-value="Id"
            multiple
            label="Course Prerequisites"
            v-model="form.PrerequisiteCourse"
          ></v-autocomplete>
          <v-select
            clearable
            v-model="form.PractitionorCertificationLevel"
            :items="filterPractitionerList"
            label="Practitioner Certification Level"
          ></v-select>
          <v-select
            :items="GetCourses"
            v-model="form.Instructor"
            item-text="Title"
            item-value="Id"
            clearable
            label="Instructor - Courses Taught"
          ></v-select>
        </v-card>
        <v-card-actions class="pb-4 mx-3">
          <v-spacer></v-spacer>
          <v-btn
            class="px-14 py-6 text_style"
            color="grey lighten-1"
            text
            @click="closeCategorydialog()"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="disabledSavebtn"
            color="primary"
            class="px-14 py-6 text_style"
            @click="send()"
          >
            <v-progress-circular
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
            <span v-if="!btnloader" class="pa-4"> Save </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!----------Edit dialog------------------>
    <v-dialog v-model="editdialog" persistent max-width="600">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <h5>Edit</h5>
          <v-icon @click="editdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <UploadfileComponent
            v-if="editdialog"
            @close-dialog="closeModal"
            :editDialog="editdialog"
            :selectedRowData="selectedRowData"
          />
        </div>
      </v-card>
    </v-dialog>
    <!----------Delete dialog------------------>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="DeleteDownloadFile()"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import createnewgroupComponent from "../../components/download/createnewgroup.component.vue";
import UploadfileComponent from "../../components/download/uploadfile.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
export default {
  components: {
    createnewgroupComponent,
    UploadfileComponent,
    ErrorToastComponent,
  },
  data() {
    return {
      filterObj: {},
      seachTimer: 0,
      search: "",
      disabledSavebtn: false,
      DeleteDownloadFileId: null,
      selectedRowData: {},
      newcategorydialog: false,
      isPlaying: false,
      filterinstructor: [],
      filtervisbiltyList: ["Visible", "Invisible"],

      filterModality: [],

      filterLanguage: [
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
        "English",
      ],
      filterPractitionerList: ["CBP", "AdvCBP", "CBP-A", "PaRama CBP"],
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageSize: 10,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      ErrorToast: false,
      uploadfiledialog: false,
      createnewgroupdialog: false,
      editdialog: false,
      btnloader: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Display Order", value: "DisplayOrder" },
        { text: "Title", value: "Title" },
        { text: "Language", value: "Languages" },
        { text: "Group", value: "DownloadFileGroup.Name" },
        { text: "Last update", value: "CreatedDate" },
        { text: "", value: "Visibility", sortable: false },
      ],
      form: {
        Name: "",
        PrerequisiteCourse: "",
        PractitionorCertificationLevel: "",
        Memberships: [],
        Instructor: "",
      },
      InstructorsArray: [],
      filtersArray: [],
    };
  },
  validations: {
    form: {
      Name: { required },
      Memberships: { required },
    },
  },

  computed: {
    ...mapGetters([
      "GetUserRolePermissions",
      "getMembership",
      "GetCourses",
      "GetDownloadFiles",
      "GetDownloadFileGroups",
      "GetInstructors",
    ]),

    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetDownloadFiles.length
        : this.itemsPerPage;
    },
  },

  mounted() {
    this.fetchInitialData();
    this.$store.dispatch("GetInstructors").then(() => {
      this.InstructorsArray = this.GetInstructors.map((item) => ({
        Name: `${item.FirstName} ${item.LastName}`,
        InstructorId: item.Id,
      }));
    });
  },

  methods: {
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchDownlaodFiles();
    },
    sendFilters() {
      this.filtersArray = [];
      if (this.filterObj.groupName && this.filterObj.groupName.length > 0) {
        this.filtersArray.push({
          Key: "Groups",
          Value: this.filterObj.groupName.join(","),
        });
      }

      if (this.filterObj.Languages && this.filterObj.Languages.length > 0) {
        this.filtersArray.push({
          Key: "Languages",
          Value: this.filterObj.Languages.join(","),
        });
      }

      if (this.filterObj.Visibility && this.filterObj.Visibility.length > 0) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterObj.Visibility,
        });
      }
      if (
        this.filterObj.MembershipsId &&
        this.filterObj.MembershipsId.length > 0
      ) {
        this.filtersArray.push({
          Key: "MembershipTypes",
          Value: this.filterObj.MembershipsId.join(","),
        });
      }
      if (this.filterObj.CoursesId) {
        this.filtersArray.push({
          Key: "CoursePrerequisites",
          Value: this.filterObj.CoursesId,
        });
      }
      if (this.filterObj.Permissions && this.filterObj.Permissions.length > 0) {
        this.filtersArray.push({
          Key: "PractitionerLevels",
          Value: this.filterObj.Permissions.join(","),
        });
      }
      if (this.filterObj.InstructorId) {
        this.filtersArray.push({
          Key: "Instructors",
          Value: this.filterObj.InstructorId,
        });
      }
      this.page = 1
      this.fetchDownlaodFiles();
    },
    fetchDownlaodFiles() {
      let apiParam = {
        page: this.page,
        pageSize: this.itemsPerPage === "All" ? 10000 : this.itemsPerPage,
        search: this.search,
        categories: JSON.stringify(this.filtersArray),
      };
      this.tableLoader = true;
      this.$store.dispatch("GetDownloadfiles", apiParam).then((res) => {
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.Data.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
        this.tableLoader = false;
      });
      this.filterDialog = false;
    },
    checkDate(x) {
      return moment(x).format("MM/DD/YY");
    },
    closeCategorydialog() {
      this.form.Name = "";
      this.form.PrerequisiteCourse = "";
      this.form.PractitionorCertificationLevel = "";
      this.form.Memberships = [];
      this.form.Instructor = "";
      this.newcategorydialog = false;
      this.$v.$reset();
    },

    fetchInitialData() {
      this.fetchDownlaodFiles();
      this.fetchData();
      this.$store.dispatch("getMembership");
      var obj = {
        page: 1,
        pageSize: "All",
        search: "",
        filters: "",
      };
      this.$store.dispatch("GetCourse", obj);
      this.Permission = this.GetUserRolePermissions.RolePermissions.find(
        (x) => x.Module === "Downloads"
      );
    },
    deleteRow(row) {
      this.DeleteDownloadFileId = row.Id;
      this.dialog = true;
    },
    DeleteDownloadFile() {
      const Id = this.DeleteDownloadFileId;
      this.btnloader=true;
      this.$store.dispatch("DeleteDownloadFile", Id).then((res) => {
        if (res.Status) {
          this.fetchInitialData();
          this.DdialogClose();
          this.btnloader=false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          // this.showDeleteToast();
        }
      });
    },
    closeModal(cancel) {
      // Close the modal here
      this.uploadfiledialog = false;
      this.editdialog = false;
      if (!cancel) {
        this.fetchInitialData();
        this.showSuccessToast();
      }
    },
    showSuccessToast(message = "File has been saved") {
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon:
          message.includes("failed") || message.includes("error")
            ? "error"
            : "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showDeleteToast() {
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    fetchData() {
      this.$store.dispatch("GetDownloadFileGroups");
    },
    toggleIsPlaying(item) {
      const Id = item.Id;
      this.$store.dispatch("ToggleFileVisibility", Id).then((res) => {
        if (res.Status) {
          this.fetchInitialData();
        }
      });
    },
    cleanFilter() {
      this.filterObj = {};
    },
    DdialogClose() {
      this.dialog = false;
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        this.btnloader = true;
        this.disabledSavebtn = true;
        var form = new FormData();
        form.append("Name", this.form.Name);
        this.form.Memberships.forEach((x, i) => {
          form.append(`Permissions[${i}]`, x);
        });
        if (this.form.PrerequisiteCourse) {
          // form.append("PreRequisitesCourses", this.form.PrerequisiteCourse);
          this.form.PrerequisiteCourse.forEach((x, i) => {
            form.append(`PreRequisitesCourses[${i}]`, x);
          });
        }
        if (this.form.PractitionorCertificationLevel) {
          form.append(
            "PractitionorCertificationLevel",
            this.form.PractitionorCertificationLevel
          );
        }
        if (this.form.Instructor) {
          form.append("CourseTaughtID", this.form.Instructor);
        }
        this.$store
          .dispatch("CreateDownloadFileGroup", form)
          .then((res) => {
            this.disabledSavebtn = false;
            this.btnloader = false;
            if (res.Status) {
              this.closeCategorydialog();
              this.fetchData();
              this.showSuccessToast("Group has been saved");
            } else {
              this.showSuccessToast(res.Message);
              this.btnloader = false;
              this.disabledSavebtn = false;
            }
          })
          .catch((res) => {
            this.showSuccessToast(res.message);
            this.btnloader = false;
            this.disabledSavebtn = false;
          });
      }
    },
    editRow(row) {
      this.selectedRowData = row;
      this.editdialog = true;
    },
    // downloadFile(row) {
    //   const Id = row.Id;
    //   const baseUrl = process.env.VUE_APP_IMG_URL;
    //   this.$store.dispatch("DownloadFile", Id).then(() => {
    //     window.open(`${baseUrl + "file.zip"}`);
    //   });
    // },
    downloadFile(url) {
      const googleDriveUrl = url;
      window.open(googleDriveUrl, "_blank")
    },
  },
  watch: {
    search() {
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.page=1
        this.fetchDownlaodFiles();
      }, 700);
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  color: rgba(34, 34, 34, 1);
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.handle {
  cursor: move;
}
tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.01);
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.pprint {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.text-styling {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.25px;
  color: #0071bd;
  text-transform: none;
}
.filter_text {
  font-family: "Mulish";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 137%;
  letter-spacing: 0.02em;
  color: #3f3d56;
}
</style>
